//import { saveAs } from "file-saver"
//import JSZip from "jszip"

export default function(fileContents, archiveName) {
    //console.log(fileContents.length);
    if (fileContents.length == 1) {
        var blob = new Blob(
            [fileContents[0].content],
            {type: fileContents[0].type || "text/plain;charset=utf-8"}
        );
        return import("file-saver").then(
            ({ saveAs }) => {
                saveAs(blob, fileContents[0].name);
                return Promise.resolve();
            }
        );
    } else {
        return import("jszip").then(
            ({default: JSZip}) => {
                //console.log(JSZip);
                var zip = new JSZip(), content;
                fileContents.forEach((fileContent) => {
                    zip.file(fileContent.name, fileContent.content);
                });
                return zip.generateAsync(
                    {type:"blob"}
                ).then(function(zipContent) {
                    // Force download of the Zip file
                    content = zipContent;
                    return import("file-saver");
                }).then(
                    ({ saveAs }) => {
                        saveAs(content, archiveName || "archive.zip");
                        return Promise.resolve();
                    }
                );
            }
        );
    }
}